import { ROUTES } from "../../constant";
import { ScreenTypes } from "../../enums";
import { iOpenResultDetail } from "../../context/globalContext/interface";

export const isBookingResultDetail = (detail: iOpenResultDetail | null | undefined): boolean =>
  detail?.source === "booking";

export const isResultDetailOnMobileRoute = (detail: iOpenResultDetail, pathname: string): boolean =>
  pathname === (isBookingResultDetail(detail) ? ROUTES.BookingInProgress : ROUTES.TopDestination);

export const isResultDetailOnDesktopScreen = (
  detail: iOpenResultDetail,
  firstScreen: string,
  screen: string
): boolean =>
  isBookingResultDetail(detail)
    ? screen === ScreenTypes.newBooking
    : firstScreen === ScreenTypes.topDestination && screen === "";
